"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.isReturns = void 0;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // Generated by CoffeeScript 2.3.2


var key;
key = '__ad-hok-returns'; // eslint-disable-next-line known-imports/no-unused-vars

var isReturns = function isReturns(val) {
  try {
    if (!(key in val)) {
      return false;
    }

    return [val[key]];
  } catch (error) {
    return false;
  }
};

exports.isReturns = isReturns;

function _default(callback) {
  return function (props) {
    return _defineProperty({}, key, callback(props));
  };
}

;